import { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useGraphql } from '@app/hooks/useGraphql';
import { GraphqlQueryDataResponse } from '@insights_module/types/graphql/ClientTypes';

interface useGraphqlAudioGenAIProps extends UseQueryOptions {
  audioId: string;
}

export const useGraphqlAudioGenAI = ({ audioId, enabled, ...props }: useGraphqlAudioGenAIProps) => {
  const { data, ...rest } = useGraphql({
    ...props,
    queryKey: ['graphql', 'graphql-audio-gen-ai', audioId, enabled],
    graphqlQuery: audioGenAIQuery,
    variables: { audioId },
    enabled: !!audioId && enabled,
  }) as { data: GraphqlQueryDataResponse } & UseQueryResult<unknown, unknown>;

  return { data: data?.data?.audio?.gen_ai, ...rest };
};

const audioGenAIQuery = `query AudioDetails($audioId: String) {
  audio(id: $audioId) {
    gen_ai {
      twitter
      facebook
      instagram
      linkedin
      show_notes
      summary
      article
    }
  }
}
`;
